import React, { Suspense, useContext, useEffect, useRef } from "react";

import { Navigate, useLocation } from "react-router";
import Navigation from "../Layouts/Navigation";
import { AuthContext } from "../Context/AuthContext";
import { hasAffiliate, publicRoutesName } from "../Utils/utils";
import RoundLoaderWithOverlay from "../Components/Common/Loader/RoundLoader";

const PublicRoutes = ({ component: RouteComponent, ...rest }) => {
  const { userData, authUser } = useContext(AuthContext);
  const { pathname } = useLocation();
  const isAuthenticating = userData?.isFetching;
  const hasRestoredSignInSession = useRef(false);

  useEffect(() => {
    //const  meta = document.createElement("meta");
    var meta = document.getElementById("metaDescription");

    if (pathname === "/sign-in") {
      document.title = "Saleoid Login";
      meta.name = "description";
      meta.content = "Sign in to your Saleoid account";
    } else if (pathname === "/signup") {
      document.title = "Sign up with Saleoid";
      meta.name = "description";
      meta.content = "Sign up to create your Saleoid account";
    } else if (pathname === "/verify-email") {
      document.title = "Verify Email";
      meta.name = "description";
      meta.content = "Verify Email";
    } else {
      document.title = "Saleoid";
      meta.name = "description";
      meta.content = "Saleoid";
    }
    //document.getElementsByTagName("head")[0].appendChild(meta);
  }, [pathname]);

  useEffect(() => {
    if (pathname !== "/sign-in") {
      hasRestoredSignInSession.current = false;
      return;
    }

    if (
      !hasRestoredSignInSession.current &&
      !userData?.authenticated &&
      !userData?.isFetching
    ) {
      hasRestoredSignInSession.current = true;
      authUser({
        allowPublicRoute: true,
        redirectOnUnauthenticated: false,
      });
    }
  }, [authUser, pathname, userData?.authenticated, userData?.isFetching]);

  const executePublicRoute = (rest) => {
    if (isAuthenticating) {
      return <RoundLoaderWithOverlay />;
    }

    if (userData?.authenticated && pathname === "/sign-in") {
      const hasSelectedTeam = Boolean(userData?.authData?.currentTeam?.id);
      return (
        <Navigate
          to={
            hasAffiliate(userData) || hasSelectedTeam
              ? "/dashboard"
              : "/choose-company"
          }
          replace
        />
      );
    }

    const isExplicitPublicRoute =
      publicRoutesName.filter(
        (item) => item !== "/signup" && pathname.includes(item)
      ).length > 0;

    if (isExplicitPublicRoute) {
      return <RouteComponent />;
    } else if (userData.authenticated) {
      if (hasAffiliate(userData)) {
        return <Navigate to="/dashboard" />;
      } else if (
        publicRoutesName.filter((item) => pathname.includes(item)).length === 0
      ) {
        return (
          <Navigate
            to="/choose-company"
            state={{
              landingUrl:
                rest.location &&
                rest.location.state &&
                rest.location.state.landingUrl
                  ? rest.location.state.landingUrl
                  : "/dashboard",
            }}
          />
        );
      } else if (pathname !== "/signup" || pathname !== "verify-email") {
        return <Navigate to="/dashboard" />;
      } else {
        return <RouteComponent />;
      }
    }

    if (!userData?.authenticated) {
      return <RouteComponent />;
    }

    return <RouteComponent />;
  };

  /*******/
  return (
    <>
      {rest.hasNavigation && <Navigation />}
      <Suspense fallback={<RoundLoaderWithOverlay />}>
        {executePublicRoute(rest)}
      </Suspense>
    </>
  );
};
export default PublicRoutes;
